import { createContext } from 'react';
import noop from '../../../utils/noop';

export default createContext({
  defaultSelectedValue: undefined,
  name: '',
  onChange: noop,
  selectedValue: undefined,
});
